
const namePre = 'Operation.'
export default {
    path: '/operation',
    name: 'Operation',
    component: resolve => {
        require.ensure([], () => {
            resolve(require('../../views/operation/Index.vue'))
        })
    },
    children: [{ // 登记
        path: 'register',
        name: namePre + 'Register',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/operation/Register.vue'))
            })
        },
        meta: {
            permission: 'Pages.Operation.Register'
        }
    }, { // 审批
        path: 'approve',
        name: namePre + 'Approve',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/operation/Approve.vue'))
            })
        },
        meta: {
            permission: 'Pages.Operation.Approve'
        }
    }, { // 出入厂区
        path: 'gateEntrance',
        name: namePre + 'GateEntrance',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/operation/GateEntrance.vue'))
            })
        },
        meta: {
            permission: 'Pages.Operation.GateEntrance'
        }
    }, { // 查询
        path: 'query',
        name: namePre + 'Query',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/operation/Query.vue'))
            })
        },
        meta: {
            permission: 'Pages.Operation.Query'
        }
    }]
}



// WEBPACK FOOTER //
// ./src/router/operation/index.js